import { fieldToTextField } from 'formik-mui';
import { TextField } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';

/**
 * List of custom fields used in formik-mui forms
 * @param {*} props 
 * @returns 
 */
export const MuiTextFieldFormik = (props) => {
    return (
      <TextField  {...fieldToTextField(props)}/>
    )
}

export const MuiTelInputFormik = (props) => {
  const { form, field, helperText, ...rest } = props;
  const { name, value, onBlur } = field;
  const touched = form.touched[name];
  const error = touched && form.errors[name];

  return (
    <MuiTelInput
      {...rest}
      name={name}
      value={value || ''}
      onChange={(val) => {
        form.setFieldValue(name, val);
      }}
      onBlur={onBlur}
      error={Boolean(error)}
      helperText={error || helperText || ' '}
      defaultCountry="IN"
      forceCallingCode
    />
  );
};
